var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.id)?_c('router-view',{attrs:{"groupid":_vm.groupid,"individualid":_vm.id}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }